// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inventory-card {\n  border-radius: 10px !important;\n}\n.inventory-card.active-card {\n  border: 3px solid #2196f3 !important;\n}\n.inventory-card.active-card .overline.color {\n  color: #2196f3;\n  font-weight: 600;\n  font-size: 14px !important;\n}\n.inventory-card .box {\n  position: absolute !important;\n  top: 8px;\n  right: 8px;\n  background: whitesmoke !important;\n}", ""]);
// Exports
module.exports = exports;
